import { Pipe, PipeTransform } from '@angular/core';
import { UiTranslationService, TranslationParams } from './services/ui-translation.service';

@Pipe({ name: 't', pure: false })
export class UiTranslatePipe implements PipeTransform {
  constructor(private readonly translations: UiTranslationService) {}

  transform(key: string, params?: TranslationParams): string {
    return this.translations.translate(key, params);
  }
}
